import { ChangeDetectionStrategy, Component, computed } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { StateService } from "../../services/state.service";
import { normalizeSocChannelType } from "../../services/soc.chat.channel.util";
import { SocChatExternalType, SocChatExternalTypeValue } from "../../services/standout.classroom.service";
import { S25ChatComponent } from "../s25.chat.component";

function parseSocChannelId(value?: string): number | undefined {
    const trimmed = value?.trim();
    if (!trimmed) {
        return undefined;
    }
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : undefined;
}

function parseExternalType(value?: string): SocChatExternalTypeValue | undefined {
    const trimmed = value?.trim();
    if (trimmed === SocChatExternalType.Event || trimmed === SocChatExternalType.Workflow) {
        return trimmed;
    }
    return undefined;
}

@TypeManagerDecorator("s25-chat-page")
@Component({
    selector: "s25-chat-page",
    standalone: true,
    imports: [S25ChatComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "chat-page-host",
    },
    styles: [
        `
            :host {
                display: block;
                flex: 1 1 auto;
                min-height: 0;
                height: 100%;
            }
        `,
    ],
    template: `
        <s25-chat
            [channelId]="channelId()"
            [channelTitle]="channelTitle()"
            [channelType]="channelType()"
            [socChannelId]="socChannelId()"
            [externalType]="externalType()"
        ></s25-chat>
    `,
})
export class S25ChatPageComponent {
    readonly channelId = computed(() => StateService.getSearch().externalId?.trim() || undefined);
    readonly channelTitle = computed(() => StateService.getSearch().title?.trim() || undefined);
    readonly channelType = computed(() => normalizeSocChannelType(StateService.getSearch().channelType));
    readonly socChannelId = computed(() => parseSocChannelId(StateService.getSearch().socChannelId));
    readonly externalType = computed(() => parseExternalType(StateService.getSearch().externalType));
}
